import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";
import { isIOS, isStandalone, registerSW, track, trackOpen } from "@/lib/pwa";

const HIDE_KEY = "wm_install_hidden";

const IOSSteps = ({ onClose }) => (
  <div className="ib-ios" role="dialog" aria-label="Install on iPhone" data-testid="install-ios-steps">
    <button type="button" className="ib-x" onClick={onClose} aria-label="Close" data-testid="install-ios-close"><X size={16} /></button>
    <strong>Add Wax Moi to your Home Screen</strong>
    <ol>
      <li>Tap <Share size={15} /> <b>Share</b> at the bottom of Safari</li>
      <li>Choose <SquarePlus size={15} /> <b>Add to Home Screen</b></li>
      <li>Tap <b>Add</b></li>
    </ol>
  </div>
);

export const InstallBar = () => {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem(HIDE_KEY) === "1");
  const [ios, setIos] = useState(false);

  useEffect(() => {
    registerSW();
    trackOpen();
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { track("install"); localStorage.setItem(HIDE_KEY, "1"); setHidden(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (hidden || (!prompt && !isIOS())) return null;
  const close = () => { localStorage.setItem(HIDE_KEY, "1"); setHidden(true); };
  const install = async () => {
    if (!prompt) { setIos(true); return; }
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };
  return (
    <div className="ib" data-testid="install-bar">
      <img src="/icon-192.png" alt="" className="ib-icon" />
      <span className="ib-text"><strong>Get the Wax Moi app</strong><small>Book faster from your home screen</small></span>
      <button type="button" className="ib-btn" onClick={install} data-testid="install-app-button"><Download size={14} /> Install</button>
      <button type="button" className="ib-x" onClick={close} aria-label="Close" data-testid="install-bar-close"><X size={16} /></button>
      {ios && <IOSSteps onClose={() => setIos(false)} />}
    </div>
  );
};
